import { getAccessToken } from "@newsenec/auth-provider";
import { registerPath, UserNotification, UserRegistrationRequest } from "./api";
import { buildFetchErrorObj } from "@newsenec/logging";
import { mfShorty } from "../constants";
import { ErrorSerial } from "../ErrorSerial";

const notificationServiceUrl = process.env.NOTIFICATION_SERVICE_URL ?? location.origin + "/api/notification";

export const fetchNotifications = async (): Promise<UserNotification[]> => {
    const token = await getAccessToken();
    const method = "GET";
    const response = await fetch(notificationServiceUrl, {
        method,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
    });

    if (response.ok) {
        return response.json();
    }

    return buildFetchErrorObj(mfShorty, method, response, ErrorSerial.NOTIFICATIONS).then((e) => Promise.reject(e));
};

export async function sendRegisterRequest(registration: UserRegistrationRequest): Promise<UserRegistrationRequest> {
    const token = await getAccessToken();
    const method = "POST";
    const response = await fetch(notificationServiceUrl + registerPath, {
        method,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(registration),
    });

    if (response.ok) {
        return response.json();
    }

    return buildFetchErrorObj(mfShorty, method, response, ErrorSerial.REGISTRATION).then((e) => Promise.reject(e));
}
